// @generated by protobuf-ts 2.9.0
// @generated from protobuf file "device_service.proto" (package "aeolus.proto", syntax proto3)
// tslint:disable
//
//
// Copyright (c) 2022 Cambridge Design Partnership.
// All rights reserved.
//
//
//*
// Defines the DeviceService service, and its request/response types
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { ConfigParams } from "./common";
import { Timestamp } from "./common";
import { Sim } from "./services_common";
import { DeviceMetadata } from "./services_common";
import { DeviceStatus } from "./common";
/**
 * @generated from protobuf message aeolus.proto.GetDeviceIdsRequest
 */
export interface GetDeviceIdsRequest {
}
/**
 * @generated from protobuf message aeolus.proto.GetDeviceIdsResponse
 */
export interface GetDeviceIdsResponse {
    /**
     * / The set of IDs for all devices known by the system
     *
     * @generated from protobuf field: repeated string id = 1;
     */
    id: string[];
}
/**
 * @generated from protobuf message aeolus.proto.GetDeviceDetailsRequest
 */
export interface GetDeviceDetailsRequest {
    /**
     * / The set of IDs whose statuses (and status changes) should be streamed in the response
     *
     * @generated from protobuf field: repeated string id = 1;
     */
    id: string[];
}
/**
 * @generated from protobuf message aeolus.proto.GetDeviceDetailsResponse
 */
export interface GetDeviceDetailsResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: aeolus.proto.DeviceStatus status = 2;
     */
    status?: DeviceStatus;
    /**
     * @generated from protobuf field: aeolus.proto.DeviceMetadata metadata = 3;
     */
    metadata?: DeviceMetadata;
    /**
     * @generated from protobuf field: aeolus.proto.Sim sim = 4;
     */
    sim?: Sim;
}
/**
 * @generated from protobuf message aeolus.proto.SetDeviceMetadataRequest
 */
export interface SetDeviceMetadataRequest {
    /**
     * / The device whose metadata should be updated
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: aeolus.proto.DeviceMetadata metadata = 2;
     */
    metadata?: DeviceMetadata;
}
/**
 * @generated from protobuf message aeolus.proto.SetDeviceMetadataResponse
 */
export interface SetDeviceMetadataResponse {
}
/**
 * @generated from protobuf message aeolus.proto.GetRequestedDeviceConfigRequest
 */
export interface GetRequestedDeviceConfigRequest {
    /**
     * The ID of the device to get config request for
     *
     * @generated from protobuf field: repeated string id = 1;
     */
    id: string[];
}
/**
 * @generated from protobuf message aeolus.proto.SetRequestedDeviceConfigResponse
 */
export interface SetRequestedDeviceConfigResponse {
}
/**
 * @generated from protobuf message aeolus.proto.GetRequestedDeviceConfigResponse
 */
export interface GetRequestedDeviceConfigResponse {
    /**
     * The ID of the device to get config request for
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * / Time at which the device config was requested. Null if there is no requested config
     *
     * @generated from protobuf field: aeolus.proto.Timestamp timestamp = 2;
     */
    timestamp?: Timestamp;
    /**
     * / The currently set requested config params for this device. Null if there is no requested config
     *
     * @generated from protobuf field: aeolus.proto.ConfigParams config_params = 3;
     */
    configParams?: ConfigParams;
}
/**
 * @generated from protobuf message aeolus.proto.SetRequestedDeviceConfigRequest
 */
export interface SetRequestedDeviceConfigRequest {
    /**
     * / The device whose config should be updated
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * / The requested config params
     *
     * @generated from protobuf field: aeolus.proto.ConfigParams config_params = 2;
     */
    configParams?: ConfigParams;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceIdsRequest$Type extends MessageType<GetDeviceIdsRequest> {
    constructor() {
        super("aeolus.proto.GetDeviceIdsRequest", []);
    }
    create(value?: PartialMessage<GetDeviceIdsRequest>): GetDeviceIdsRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetDeviceIdsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeviceIdsRequest): GetDeviceIdsRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: GetDeviceIdsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetDeviceIdsRequest
 */
export const GetDeviceIdsRequest = new GetDeviceIdsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceIdsResponse$Type extends MessageType<GetDeviceIdsResponse> {
    constructor() {
        super("aeolus.proto.GetDeviceIdsResponse", [
            { no: 1, name: "id", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetDeviceIdsResponse>): GetDeviceIdsResponse {
        const message = { id: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetDeviceIdsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeviceIdsResponse): GetDeviceIdsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string id */ 1:
                    message.id.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeviceIdsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string id = 1; */
        for (let i = 0; i < message.id.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.id[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetDeviceIdsResponse
 */
export const GetDeviceIdsResponse = new GetDeviceIdsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceDetailsRequest$Type extends MessageType<GetDeviceDetailsRequest> {
    constructor() {
        super("aeolus.proto.GetDeviceDetailsRequest", [
            { no: 1, name: "id", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetDeviceDetailsRequest>): GetDeviceDetailsRequest {
        const message = { id: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetDeviceDetailsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeviceDetailsRequest): GetDeviceDetailsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string id */ 1:
                    message.id.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeviceDetailsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string id = 1; */
        for (let i = 0; i < message.id.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.id[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetDeviceDetailsRequest
 */
export const GetDeviceDetailsRequest = new GetDeviceDetailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceDetailsResponse$Type extends MessageType<GetDeviceDetailsResponse> {
    constructor() {
        super("aeolus.proto.GetDeviceDetailsResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "message", T: () => DeviceStatus },
            { no: 3, name: "metadata", kind: "message", T: () => DeviceMetadata },
            { no: 4, name: "sim", kind: "message", T: () => Sim }
        ]);
    }
    create(value?: PartialMessage<GetDeviceDetailsResponse>): GetDeviceDetailsResponse {
        const message = { id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetDeviceDetailsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDeviceDetailsResponse): GetDeviceDetailsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* aeolus.proto.DeviceStatus status */ 2:
                    message.status = DeviceStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* aeolus.proto.DeviceMetadata metadata */ 3:
                    message.metadata = DeviceMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                case /* aeolus.proto.Sim sim */ 4:
                    message.sim = Sim.internalBinaryRead(reader, reader.uint32(), options, message.sim);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDeviceDetailsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* aeolus.proto.DeviceStatus status = 2; */
        if (message.status)
            DeviceStatus.internalBinaryWrite(message.status, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* aeolus.proto.DeviceMetadata metadata = 3; */
        if (message.metadata)
            DeviceMetadata.internalBinaryWrite(message.metadata, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* aeolus.proto.Sim sim = 4; */
        if (message.sim)
            Sim.internalBinaryWrite(message.sim, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetDeviceDetailsResponse
 */
export const GetDeviceDetailsResponse = new GetDeviceDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDeviceMetadataRequest$Type extends MessageType<SetDeviceMetadataRequest> {
    constructor() {
        super("aeolus.proto.SetDeviceMetadataRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "metadata", kind: "message", T: () => DeviceMetadata }
        ]);
    }
    create(value?: PartialMessage<SetDeviceMetadataRequest>): SetDeviceMetadataRequest {
        const message = { id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetDeviceMetadataRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetDeviceMetadataRequest): SetDeviceMetadataRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* aeolus.proto.DeviceMetadata metadata */ 2:
                    message.metadata = DeviceMetadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetDeviceMetadataRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* aeolus.proto.DeviceMetadata metadata = 2; */
        if (message.metadata)
            DeviceMetadata.internalBinaryWrite(message.metadata, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.SetDeviceMetadataRequest
 */
export const SetDeviceMetadataRequest = new SetDeviceMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDeviceMetadataResponse$Type extends MessageType<SetDeviceMetadataResponse> {
    constructor() {
        super("aeolus.proto.SetDeviceMetadataResponse", []);
    }
    create(value?: PartialMessage<SetDeviceMetadataResponse>): SetDeviceMetadataResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetDeviceMetadataResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetDeviceMetadataResponse): SetDeviceMetadataResponse {
        return target ?? this.create();
    }
    internalBinaryWrite(message: SetDeviceMetadataResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.SetDeviceMetadataResponse
 */
export const SetDeviceMetadataResponse = new SetDeviceMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRequestedDeviceConfigRequest$Type extends MessageType<GetRequestedDeviceConfigRequest> {
    constructor() {
        super("aeolus.proto.GetRequestedDeviceConfigRequest", [
            { no: 1, name: "id", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GetRequestedDeviceConfigRequest>): GetRequestedDeviceConfigRequest {
        const message = { id: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetRequestedDeviceConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRequestedDeviceConfigRequest): GetRequestedDeviceConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string id */ 1:
                    message.id.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRequestedDeviceConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string id = 1; */
        for (let i = 0; i < message.id.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.id[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetRequestedDeviceConfigRequest
 */
export const GetRequestedDeviceConfigRequest = new GetRequestedDeviceConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetRequestedDeviceConfigResponse$Type extends MessageType<SetRequestedDeviceConfigResponse> {
    constructor() {
        super("aeolus.proto.SetRequestedDeviceConfigResponse", []);
    }
    create(value?: PartialMessage<SetRequestedDeviceConfigResponse>): SetRequestedDeviceConfigResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetRequestedDeviceConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetRequestedDeviceConfigResponse): SetRequestedDeviceConfigResponse {
        return target ?? this.create();
    }
    internalBinaryWrite(message: SetRequestedDeviceConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.SetRequestedDeviceConfigResponse
 */
export const SetRequestedDeviceConfigResponse = new SetRequestedDeviceConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRequestedDeviceConfigResponse$Type extends MessageType<GetRequestedDeviceConfigResponse> {
    constructor() {
        super("aeolus.proto.GetRequestedDeviceConfigResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "config_params", kind: "message", T: () => ConfigParams }
        ]);
    }
    create(value?: PartialMessage<GetRequestedDeviceConfigResponse>): GetRequestedDeviceConfigResponse {
        const message = { id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<GetRequestedDeviceConfigResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetRequestedDeviceConfigResponse): GetRequestedDeviceConfigResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* aeolus.proto.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* aeolus.proto.ConfigParams config_params */ 3:
                    message.configParams = ConfigParams.internalBinaryRead(reader, reader.uint32(), options, message.configParams);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetRequestedDeviceConfigResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* aeolus.proto.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* aeolus.proto.ConfigParams config_params = 3; */
        if (message.configParams)
            ConfigParams.internalBinaryWrite(message.configParams, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.GetRequestedDeviceConfigResponse
 */
export const GetRequestedDeviceConfigResponse = new GetRequestedDeviceConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetRequestedDeviceConfigRequest$Type extends MessageType<SetRequestedDeviceConfigRequest> {
    constructor() {
        super("aeolus.proto.SetRequestedDeviceConfigRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "config_params", kind: "message", T: () => ConfigParams }
        ]);
    }
    create(value?: PartialMessage<SetRequestedDeviceConfigRequest>): SetRequestedDeviceConfigRequest {
        const message = { id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SetRequestedDeviceConfigRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SetRequestedDeviceConfigRequest): SetRequestedDeviceConfigRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* aeolus.proto.ConfigParams config_params */ 2:
                    message.configParams = ConfigParams.internalBinaryRead(reader, reader.uint32(), options, message.configParams);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SetRequestedDeviceConfigRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* aeolus.proto.ConfigParams config_params = 2; */
        if (message.configParams)
            ConfigParams.internalBinaryWrite(message.configParams, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.SetRequestedDeviceConfigRequest
 */
export const SetRequestedDeviceConfigRequest = new SetRequestedDeviceConfigRequest$Type();
/**
 * @generated ServiceType for protobuf service aeolus.proto.DeviceService
 */
export const DeviceService = new ServiceType("aeolus.proto.DeviceService", [
    { name: "GetDeviceIds", serverStreaming: true, options: {}, I: GetDeviceIdsRequest, O: GetDeviceIdsResponse },
    { name: "GetDeviceDetails", serverStreaming: true, options: {}, I: GetDeviceDetailsRequest, O: GetDeviceDetailsResponse },
    { name: "SetDeviceMetadata", options: {}, I: SetDeviceMetadataRequest, O: SetDeviceMetadataResponse },
    { name: "GetRequestedDeviceConfig", serverStreaming: true, options: {}, I: GetRequestedDeviceConfigRequest, O: GetRequestedDeviceConfigResponse },
    { name: "SetRequestedDeviceConfig", options: {}, I: SetRequestedDeviceConfigRequest, O: SetRequestedDeviceConfigResponse }
]);
